






import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';

// TODO: fix
/* tslint:disable:no-empty */

@Component({
    components: {BButton},
})
export default class CoinFooter extends Vue {
    @Prop() public isSave: boolean | undefined;

    constructor() {
        super();

    }
    public triggerEmit() {
        if (this.isSave) {
            this.save();
            return;
        }
        this.close();
    }
    @Emit('save')
    public save() {
    }
    @Emit('close')
    public close() {
    }

}
